import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propChildren, propFunc, propNumber, propShape, propStr, } from '../../../helpers/custom-prop-types';
import InputError from './InputError';
import PlainInput from './PlainInput';
const PlainInputComponent = (props) => {
    const { afterPrefix, autoComplete, className, defaultValue, disabled, id, input, maxLength, meta, placeholder, showError, type, wrapOnBlur, } = props;
    return (_jsxs(_Fragment, { children: [_jsx(PlainInput, { autoComplete: autoComplete || 'off', className: className, defaultValue: defaultValue, disabled: disabled, id: id, input: input, maxLength: maxLength || null, meta: meta, placeholder: placeholder, type: type, wrapOnBlur: wrapOnBlur }), afterPrefix, showError && _jsx(InputError, { meta: meta })] }));
};
PlainInputComponent.propTypes = {
    afterPrefix: propChildren(),
    autoComplete: propStr(),
    className: propStr().isRequired,
    defaultValue: propStr(),
    disabled: propBool(),
    id: propStr(),
    input: propShape().isRequired,
    maxLength: propNumber(),
    meta: propShape().isRequired,
    placeholder: propStr().isRequired,
    showError: propBool(),
    type: propStr(),
    wrapOnBlur: propFunc(),
};
PlainInputComponent.defaultProps = {
    afterPrefix: '',
    autoComplete: '',
    defaultValue: undefined,
    disabled: false,
    id: undefined,
    maxLength: null,
    showError: true,
    type: 'text',
    wrapOnBlur: null,
};
export default PlainInputComponent;
